/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { TextField } from "@mui/material";
import { ContentZoneContext } from "cms/components/context";
import { useUpdateComponent } from "cms/components/hooks/use-update-component";
import { DOCUMENT_LIST } from "cms/documents/document/helpers";
import LabelledField from "components/labelled-field";
import { useContext } from "react";
import { isStringNotEmpty } from "utils/empty-exists";
import { DocumentListComponentEditWrapper } from "./component-document-list-wrapper";
import { Document } from "./document";
import { SettingsDialog } from "./settings-dialog";

const titlePlaceHolder = "Add list title (optional)";
const DEFAULT_LIST_STYLE = DOCUMENT_LIST.ICON;

const DocumentListComponentEditor = () => {

    const { defaultImpl } = useContext(ContentZoneContext);
    const { component, update, updateFactory } = useUpdateComponent();

    const onChangeTitle = (event) => {
        const title = event.target.value;
        update("title", title);
    };
    const onChangeListStyle = (value) => {
        const listStyle = isStringNotEmpty(value) ? value : DEFAULT_LIST_STYLE;
        update("listStyle", listStyle);
    };

    const onChangeSettings = updateFactory("settings");
    const onChangeList = updateFactory("documents");

    return (
        <div className='simplicity-editor-frame'>

            {/*  Title  */}
            <LabelledField label='Title:'>
                <TextField
                    id='document_list_title'
                    fullWidth={true}
                    placeholder={titlePlaceHolder}
                    value={component.title}
                    onChange={(e) => onChangeTitle(e)}
                />
            </LabelledField>

            {/*  Settings Dialog  */}
            <SettingsDialog
                listStyle={component.listStyle}
                onChangeListStyle={onChangeListStyle}
                settings={component.settings}
                onChangeSettings={onChangeSettings}
                open={open}
            />

            {/*  Document List  */}
            <DocumentListComponentEditWrapper
                list={component.documents}
                onChangeList={onChangeList}
                defaultImpl={defaultImpl}
            >
                
                <Document />
                
            </DocumentListComponentEditWrapper>
        </div>
    );
};

DocumentListComponentEditor.displayName = "DocumentListComponentEditor";
export { DocumentListComponentEditor };

